import React from 'react';
import { LightTooltip } from './LightTooltip';
import styles from './stockStyles';

export const ExDiveObject = ({ exToolTip, isMobile }) => {
	return (
		<LightTooltip
			placement='bottom'
			// leaveDelay={1500}
			title={exToolTip}
		>
			<div style={{ ...styles.ExDivObject }}>
				<div style={{ padding: '2px  0px' }}>D</div>
			</div>
		</LightTooltip>
	);
};



// WEBPACK FOOTER //
// ./src/Pages/Stock/ExDiveObject.jsx